export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavTitle',
        _children: ['OW Interactive']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Clientes',
        to: '/customers',
        icon: 'cil-people'
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Projetos',
        icon: 'cil-folder-open',
        items: [
          {
            name: 'Categorias',
            to: '/categories'
          },
          {
            name: 'Projetos',
            to: '/projects'
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Carreira',
        icon: 'cil-briefcase',
        items: [
          {
            name: 'Vagas',
            to: '/jobs'
          },
          {
            name: 'Currículos',
            to: '/jobaplications'
          }
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Contatos',
        to: '/contacts',
        icon: 'cil-envelope-closed'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Administrativo']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Usuários',
        to: '/users',
        icon: 'cil-user'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'SEO',
        to: '/seo',
        icon: 'cil-chart'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Logs',
        href: `${process.env.VUE_APP_API_URL}/log/download`,
        icon: 'cil-notes'
      }
    ]
  }
]
